import { createRouter, createWebHistory } from 'vue-router';
// Layouts
import BasicLayout from '../layouts/BasicLayout.vue';
import MainLayout from '../layouts/MainLayout.vue';
import SinFooterLayout from '../layouts/SinFooter.vue';
// Pages
import Home from '../views/Home.vue';
import Terranova from '../views/Terranova.vue';
import Norterra from '../views/Norterra.vue';
import Contacto from '../views/Contacto.vue';

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: 'terranova',
        name: 'Terranova',
        component: Terranova
      }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: 'contacto',
        name: 'Contacto',
        component: Contacto
      },
    ]
  },
  {
    path: '/',
    component: SinFooterLayout,
    children: [
      {
        path: 'norterra',
        name: 'Norterra',
        component: Norterra
      },
    ]
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;